import type { State } from '../../../model/types.tsx';

export const getAppProps = (state: State) => state.appProps;
export const getLocale = (state: State) => getAppProps(state).locale;
export const getProjectId = (state: State) => getAppProps(state).projectId;
export const getProjectKey = (state: State) => getAppProps(state).projectKey;
export const getEnvironment = (state: State) => getAppProps(state).environment;
export const isProjectAdmin = (state: State) => getAppProps(state).isProjectAdmin;
export const isProjectSimplified = (state: State) => getAppProps(state).isProjectSimplified;
export const isJSMChatInstalled = (state: State) => getAppProps(state).isJSMChatInstalled;
